export default "__VITE_ASSET__BE79XTH4__"